module.exports = __webpack_public_path__ + "1521375da10f05cc0d969decd345b884.svg";